import { borderBottom } from "@mui/system";
import DebugBox from "components/shareable/DebugBox";
import ButtonSymphony from "elements/ButtonSymphony";
import CampaignInfoSymphony from "elements/CampaignInfoSymphony";
import CardSymphony from "elements/CardSymphony";
import PageSymphony from "elements/PageSymphony";
import SwitchSymphony from "elements/SwitchSymphony";
import useCampaignsDashboard from "Hooks/useCampaignsDashboard";
import Colors from "modules/Colors";
import Sty from "modules/Sty";
import { makeKey } from "modules/Utils";
import { CSSProperties, useEffect, useState } from "react";

const CampaignsDashboard = () => {
    const {
        campaignsDashboard,
        isLoadingCampaignsDashboard,
        getCampaignsDashboard
    } = useCampaignsDashboard();

    const [showDebugBox, setShowDebugBox] = useState<boolean[]>(campaignsDashboard.map(() => false));

    useEffect(() => {
        getCampaignsDashboard({
            isAll: true,
        });
    }, []);

    useEffect(() => {
        setShowDebugBox(campaignsDashboard.map(() => false));
    }, [campaignsDashboard]);

    const renderRefreshButton = () => {
        return (
            <ButtonSymphony
                className="campaignsDashboardRefreshButton"
                variant="text"
                onClick={() => getCampaignsDashboard({ isAll: true })}
                isLoading={isLoadingCampaignsDashboard}
                loadingText="Refreshing Campaigns..."
            >
                Refresh
            </ButtonSymphony>
        )
    }

    const renderCampaignInfoButtons = (campaign: any) => {
        return (
            <ButtonSymphony
                className="campaignsDashboardCampaignInfoButton"
                variant="text"
                onClick={() => {
                    console.log('campaign', campaign);
                }}
            >
                Duplicate
            </ButtonSymphony>
        )
    }

    const renderCampaignsDashboard = () => {
        return (
            <div
                className="campaignsDashboardContainer"
                style={sty.campaignsDashboardContainer}
            >
                {campaignsDashboard.map((campaign, index) => (
                    <div
                        key={makeKey(campaign, index)}
                        className="campaignsDashboardCard"
                        style={sty.campaignsDashboardCard}
                    >
                        <CampaignInfoSymphony
                            key={makeKey(campaign, index)}
                            className="campaignsDashboardCardCampaignInfo"
                            campaign={campaign as any}
                            isBorderBottom={false}
                            childrenButtons={renderCampaignInfoButtons(campaign)}
                        />
                        <SwitchSymphony
                            className="campaignsDashboardCardSwitch"
                            checked={showDebugBox[index]}
                            onChange={(checked) => setShowDebugBox(showDebugBox.map((_, i) => i === index ? checked : _))}
                            label="Show Data"
                        />
                        {showDebugBox[index] &&
                            <DebugBox
                                alwaysShow
                                data={{ campaign }}
                            />
                        }
                    </div>
                ))}
            </div>
        )
    }

    return (
        <PageSymphony
            className="campaignsDashboardPage"
            isContent
        >
            <CardSymphony
                className="campaignsDashboardCard"
                title="Campaigns Dashboard"
                subtitle="View your campaigns dashboard"
                isLoading={isLoadingCampaignsDashboard}
            >
                {renderRefreshButton()}
                {renderCampaignsDashboard()}
            </CardSymphony>
        </PageSymphony>
    )
}

const sty: Record<string, CSSProperties> = {
    campaignsDashboardCard: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        borderBottom: Sty.border,
        paddingBottom: 16
    },
}

export default CampaignsDashboard;